import { LiaTimesCircle } from "react-icons/lia";
import { IoMdDownload } from "react-icons/io";
import styles from "./RptBody.module.css";
import { downloadFileToLocal } from "../../../../Shared_utilities/fileDownloadUtils";
import { useMixPanelForTracking } from "../../../../Shared_utilities/trackmixpanel";
import { useAzureUpload } from "../../../../hooks/useAzureFileUpload";

export default function FileUploadSection({
  uploadState,
  setUploadState,
  fileInputRef,
}) {
  const {TrackMixPanel} = useMixPanelForTracking()
  const { uploadFile, isUploading } = useAzureUpload();

  const handleFileChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];

      setUploadState({
        file: selectedFile,
        loading: true,
        error: null,
        blobUrl: null,
        fileName: selectedFile.name,
      });

      try {
        const filename = `rpt_uploads/${Date.now()}_${selectedFile.name}`;
        const { blobUrl, fileName } = await uploadFile(selectedFile, filename);

        setUploadState((prev) => ({
          ...prev,
          loading: false,
          blobUrl,
          fileName,
        }));
        TrackMixPanel({
          Definition:"user has uploaded a file.",
          ModuleName:"lorri ai",
          ScreenName:"rpt"
        })
      } catch (err) {
        console.error("Upload failed:", err);
        setUploadState((prev) => ({
          ...prev,
          loading: false,
          error:
            "Upload failed. Please try again or check if your file has the correct headers.",
        }));
      }
    }
  };

  const handleFileReset = () => {
    setUploadState({
      file: null,
      loading: false,
      error: null,
      blobUrl: null,
      fileName: null,
    });

    if (fileInputRef?.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDownloadRPTTemplate = async () => {
    const templateURL =
      "https://rnrdeploynew.blob.core.windows.net/staticfiles/rpt_standard_template_file.xlsx";
    downloadFileToLocal(templateURL);
  };

  return (
    <div className={`${styles.formRow} ${styles.uploadRow}`}>
      <div className={styles.uploadMessage}>
        <div>Upload an Excel file (.xlsx)</div>
        <span
          className={`${styles.fileRequirement} ${
            uploadState.error ? styles.hintText : ""
          }`}
        >
          (File must contain <b>Origin</b>, <b>Destination</b>,{" "}
          <b>Truck Type</b>, and <b>Date</b> columns)
        </span>
      </div>

      <div className={styles.customFileUpload}>
        <input
          type="file"
          accept=".xlsx"
          onChange={handleFileChange}
          id="file-upload"
          disabled={uploadState.loading || uploadState.fileName}
          ref={fileInputRef}
        />

        {!uploadState.fileName && !uploadState.loading && (
          <label htmlFor="file-upload" className={styles.browseBtn}>
            Browse Files
          </label>
        )}

        {uploadState.fileName && (
          <div className={styles.uploadStatus}>
            <strong>{uploadState.fileName}</strong>{" "}
            {uploadState.loading && <span>is uploading...</span>}
            {uploadState.fileName && (
              <button
                className={styles.clearBtn}
                onClick={handleFileReset}
                title="Remove uploaded file"
              >
                <LiaTimesCircle />
              </button>
            )}
          </div>
        )}

        {uploadState.error && (
          <div className={styles.errorBox}>
            <span className={styles.errorText}>{uploadState.error}</span>
            <div className="">
              <button
                onClick={handleDownloadRPTTemplate}
                className={`${styles.templateLink} btn btn-sm btn-link`}
              >
                <span className="mx-1">
                  <IoMdDownload />
                </span>
                Download Template
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
